console.log('LOADED: systemscan');

import 'bootstrap/js/modal';

$('document').ready(function () {

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires+"; path=/";
    }

    if (typeof PARTNERGET !== 'undefined' && PARTNERGET) {
        setCookie('partner', PARTNERGET, 90);
    }
    if (typeof GCLIDGET !== 'undefined' && GCLIDGET) {
        setCookie('gclid',GCLIDGET,7);
    }

    function ss_online_link () {
        $('a.link_online').attr("target", '_blank');

        $('a.link_online').map(function(i, el) {
            var $el = $(el);
            var params = $el.data('href-params');
            var href = LINKS['link_online'];

            if (params && params.length) {
                if ($el.attr('href').indexOf('?') === -1) href = href + '?' + params;
                else href = href + '&' + params;
            }

            $el.attr('href', href);
        });
    }

    if (typeof LINKS !== 'undefined' && LINKS) {
        $("a.link_win").attr("href", LINKS['link_win']);
        $("a.link_mac").attr("href", LINKS['link_mac']);
        $("a.link_linux").attr("href", LINKS['link_linux']);
        $("a.link_ipad").attr("href", LINKS['link_ipad']);
        $("a.link_iphone").attr("href", LINKS['link_iphone']);
        $("a.link_android").attr("href", LINKS['link_android']);
        $("a.link_huawei").attr("href", LINKS['link_huawei']);
        $("a.link_winstore").attr("href", LINKS['link_winstore']);

        ss_online_link();
        $(window).on('SS_ONLINE_LINK_REFRESH', ss_online_link);
        $("a.link_online").attr("href", LINKS['link_online']);
        $("a.link_online_tep").attr("href", LINKS['link_online_tep']);


        $("a.link_changer").attr("href", LINKS['link_changer']);
        if ($(".download a").hasClass('link_changer')) {
            $("#box_system_version_txt").text(SYSTEM_NAME);
        }
    }


    if (typeof PARTNER !== 'undefined' && PARTNER) {
        $('.link_partner').each(function (i, val) {
            var link_partner_href = $(this).attr("href");
            if (link_partner_href) {
                var param_pos = link_partner_href.indexOf("?");
                var param_pos_char = '?';
                if (param_pos > 0) param_pos_char = '&';
                $(this).attr("href", link_partner_href + param_pos_char + 'partner=' + PARTNER);
            }
        });
    }
/*
    if (BOX_SYSTEM_TXT.length>0) {
        $("#box_system_txt").text(BOX_SYSTEM_TXT);
    }
*/

    if (typeof PAGE_NAME !== 'undefined' && PAGE_NAME) {
        $("#navbar a.pobierz").attr("onclick", "dataLayer.push({'event': 'download_click', 'eventCategory' : 'download_" + PAGE_NAME + "', 'eventAction' : 'MENUTOP', 'eventLabel' : 'CALLACTION'});");
        $("#navbar a.online").attr("onclick", "dataLayer.push({'event': 'online_click', 'eventCategory' : 'online_" + PAGE_NAME + "', 'eventAction' : 'MENUTOP', 'eventLabel' : 'CALLACTION'});");

        $(".link_online_event").attr("onclick", "dataLayer.push({'event': 'online_click', 'eventCategory' : 'online_" + PAGE_NAME + "', 'eventAction' : 'MAIN', 'eventLabel' : 'LINK'});");
        $(".link_online_tep_event").attr("onclick", "dataLayer.push({'event': 'online_click', 'eventCategory' : 'online_" + PAGE_NAME + "', 'eventAction' : 'MAIN', 'eventLabel' : 'LINK'});");

        $(".center blockquote .link_online").attr("onclick", "dataLayer.push({'event': 'online_click', 'eventCategory' : 'online_" + PAGE_NAME + "', 'eventAction' : 'MAIN', 'eventLabel' : 'BLOCKQUOTE'});");
        $(".center blockquote.potykaczA .link_online").attr("onclick", "dataLayer.push({'event': 'online_click', 'eventCategory' : 'online_" + PAGE_NAME + "', 'eventAction' : 'MAIN', 'eventLabel' : 'BLOCKQUOTEA'});");
        $(".center blockquote.potykaczB .link_online").attr("onclick", "dataLayer.push({'event': 'online_click', 'eventCategory' : 'online_" + PAGE_NAME + "', 'eventAction' : 'MAIN', 'eventLabel' : 'BLOCKQUOTEB'});");

        $(".link_mobile_online_event").attr("onclick", "dataLayer.push({'event': 'online_click', 'eventCategory' : 'online_" + PAGE_NAME + "', 'eventAction' : 'MAIN', 'eventLabel' : 'BLOCKQUOTE'});");
        $(".link_class_android,.link_class_ipad,.link_class_iphone,.link_winstore").attr("onclick", "dataLayer.push({'event': 'mobi_click', 'eventCategory' : 'mobi_" + PAGE_NAME + "', 'eventAction' : 'MAIN', 'eventLabel' : 'BLOCKQUOTE'});");
    }

    /**
     * obsługa okna modalnego przy klikaniu w pobierz
     */
    $('body').on('click', 'a.down-modal', function() {
        $('#ep_download').modal('show');
    });

});
